<template>
  <div class="left cadfm-flexitem-fixed scrollbars">
    <div class="Tabs">
      <action-panel>
        <action-bar>
          <b-navbar-nav>
            <action-button @click="toggleLeftPanel" icon="hide" bold :text="lang.button_Hide"
              :tooltip="lang.button_Hide" :disabled="false" />
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">

          </b-navbar-nav>
        </action-bar>
        <action-content>
          <b-tabs v-model="tabIndex" card>

            <b-tab :title="lang.Content.tab_SearchHistory" :title-link-class="textColors" :title-item-class="textColors"
              active>

              <SearchHistoryTableComponent :lang="lang.Content.SearchHistoryTable"></SearchHistoryTableComponent>
            </b-tab>
            <!-- <b-tab :title="lang.Content.tab_CreatedByUser"  :title-link-class="textColors" :title-item-class="textColors"  >
            <p>{{lang.Content.infotext_1}}</p>
            
          </b-tab> -->

          </b-tabs>



        </action-content>
      </action-panel>
    </div>
  </div>
</template>



<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'
import ActionBar from '@/components/shared/ActionBar'
import ActionContent from '@/components/shared/ActionContent'
import ActionPanel from '@/components/shared/ActionPanel'
import ActionButton from '@/components/shared/ActionButton'
import SearchHistoryTableComponent from '@/components/shared/SearchHistoryTableComponent'


export default {
  name: 'Left',
  components: {
    ActionBar,
    ActionContent,
    ActionPanel,
    ActionButton,
    SearchHistoryTableComponent

  },
  props:{
    lang: Object
  },
  data () {
    return {
      title: "Categories of parts",

      categoriesButtonStatus: false,
      editCategories:false,
      tabIndex: 0
    }
  },
  computed: {
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    }
  },
  watch: {
    tabIndex: function (newVal, oldVal) {
      

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_setTabStatus", this.tabIndex);
    }
  },
  methods: {

    categories(){
      
      let to = "/PartManager/Categories";

      
      
      const query = {
        from: this.$route.path,
        to: to,

      }

      this.$router.push({ path: to, query: query }); 
    },

    toggleLeftPanel(){
      
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .left{

    border-right: 1px solid #666;
    max-width: 380px;

  }

  /*
  .col{
    padding-right: 0px;
    padding-left: 0px;
  }
  .titlecomponent{
    margin-left: 10px;
  }
  .treecomponent{
    margin-left: 10px;
  }
*/
</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartSearch/Left/Left.vue